export default __webpack_public_path__ + "static/media/barak-7.c3fa38c0.jpeg";